import { lazy } from 'react'

const NotFound = lazy(() => import('@/pages/404'));

const HomePage = lazy(() => import('@/pages/index/index'));
const LoginPage = lazy(() => import('@/pages/login'));
const Register = lazy(() => import('@/pages/login/register'));
const ResetPage = lazy(() => import('@/pages/login/reset'));
const Terms = lazy(() => import('@/pages/terms/terms'));
const Pricing = lazy(() => import('@/pages/pricing/pricing'));

const FineTuningDashboard = lazy(() => import('@/pages/fineTuning/dashboard'));
const FineTuningDatasets = lazy(() => import('@/pages/fineTuning/datasets'));
const FineTuningNewJob = lazy(() => import('@/pages/fineTuning/newJob'));
const FineTuningJobDetails = lazy(() => import('@/pages/fineTuning/jobDetails'));
const FineTuningModels = lazy(() => import('@/pages/fineTuning/models'));
const FineTuningEndpoints = lazy(() => import('@/pages/fineTuning/endpoints'));
const UserCenter = lazy(() => import('@/pages/user/user'));
const Security = lazy(() => import('@/pages/user/security'));
const Billing = lazy(() => import('@/pages/billing/billing'));
const GiftCards = lazy(() => import('@/pages/giftCards/giftCards'));
const Support = lazy(() => import('@/pages/support/support'));
const TicketDetail = lazy(() => import('@/pages/support/ticketDetail'));
const AuditLogs = lazy(() => import('@/pages/audit/auditLogs'));
const AdminUsers = lazy(() => import('@/pages/dashboard/users'));

const { KdPromptsPage, KdSettingsPage } = (() => {
	const KdPromptsPage = lazy(() => import('@/pages/dashboard/kd/KdPromptsPage'));
	const KdSettingsPage = lazy(() => import('@/pages/dashboard/kd/KdSettingsPage'));
	return { KdPromptsPage, KdSettingsPage };
})();

export interface RouteConfig {
	path: string
	component?: React.LazyExoticComponent<React.ComponentType<any>>
	redirectTo?: string
	name?: string
	exact?: boolean
	requireAuth?: boolean
	requireAdmin?: boolean
}

const routers: RouteConfig[] = [
	{
		path: '/',
		exact: true,
		component: HomePage,
		name: 'Home'
	},
	{
		path: '/index',
		redirectTo: '/',
		name: 'Index',
	},
	{
		path: '/404',
		component: NotFound,
	},
	{
		path: '/signin',
		component: LoginPage,
		name: 'SignIn'
	},
	{
		path: '/signup',
		component: Register,
		name: 'SignUp'
	},
	{
		path: '/reset',
		component: ResetPage,
		name: 'Reset'
	},
	{
		path: '/terms',
		component: Terms,
		name: 'Terms'
	},
	{
		path: '/pricing',
		component: Pricing,
		name: 'Pricing'
	},
	{
		path: '/console/fine-tuning',
		component: FineTuningDashboard,
		exact: true,
		requireAuth: true
	},
	{
		path: '/console/fine-tuning/datasets',
		component: FineTuningDatasets,
		requireAuth: true
	},
	{
		path: '/console/fine-tuning/new',
		component: FineTuningNewJob,
		requireAuth: true
	},
	{
		path: '/console/fine-tuning/jobs/:id',
		component: FineTuningJobDetails,
		requireAuth: true
	},
	{
		path: '/console/fine-tuning/models',
		component: FineTuningModels,
		requireAuth: true
	},
	{
		path: '/console/fine-tuning/endpoints',
		component: FineTuningEndpoints,
		requireAuth: true
	},
	{
		path: '/console/user',
		component: UserCenter,
		name: 'UserCenter',
		requireAuth: true
	},
	{
		path: '/console/security',
		component: Security,
		requireAuth: true
	},
	{
		path: '/console/billing',
		component: Billing,
		requireAuth: true
	},
	{
		path: '/console/gift-cards',
		component: GiftCards,
		requireAuth: true
	},
	{
		path: '/console/support',
		component: Support,
		exact: true,
		requireAuth: true
	},
	{
		path: '/console/support/:id',
		component: TicketDetail,
		requireAuth: true
	},
	{
		path: '/console/audit-logs',
		component: AuditLogs,
		name: 'AuditLogs',
		requireAuth: true
	},
	{
		path: '/dashboard',
		exact: true,
		redirectTo: '/dashboard/users',
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/users',
		component: AdminUsers,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/prompts/browse',
		component: KdPromptsPage,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/prompts/huggingface',
		component: KdPromptsPage,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/prompts/generate/synthetic',
		component: KdPromptsPage,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/prompts/generate/github',
		component: KdPromptsPage,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/prompts/disassembly',
		component: KdPromptsPage,
		requireAuth: true,
		requireAdmin: true
	},
	{
		path: '/dashboard/kd-settings',
		component: KdSettingsPage,
		requireAuth: true,
		requireAdmin: true
	}
]

export default routers